export default __webpack_public_path__ + "static/media/voicenote-screenshot-03.cf72393a.png";